import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 232.25 160.79' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M0 0v160.79h232.25V0zm113.63 98.71a16.85 16.85 0 0 1 0-33.33zm5-33.33a16.85 16.85 0 0 1 0 33.33zM8 55.65h28.26v49.49H8zm0 54.49h33.26V50.65H8V8h105.63v52.32a21.87 21.87 0 0 0 0 43.45v49H8zm110.63 42.65v-49a21.87 21.87 0 0 0 0-43.45V8h105.62v42.65H191v59.49h33.26v42.65zm105.63-47.65H196V55.65h28.26z'
        fill='undefined'
        data-name='Layer 1'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CalcettoIcon.js